"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTRICTIONS = void 0;
exports.RESTRICTIONS = {
    ACCOUNT_DISABLE: 'ACCOUNT:DISABLE',
    ATTENDANCE_VIEW_HIDE: 'ATTENDANCE_VIEW:HIDE',
    ATTENDANCE_EDIT_HIDE: 'ATTENDANCE_EDIT:HIDE',
    AUTO_GENERATE_SCHEDULE_HIDE: 'AUTO_GENERATE_SCHEDULE:GET',
    AVAILABILITIES_VIEW_DISABLE_CONFIRM: 'AVAILABILITIES_VIEW:DISABLE_CONFIRM',
    AVAILABILITIES_VIEW_HIDE: 'AVAILABILITIES_VIEW:HIDE',
    COMPANY_MANAGE_ABSENCETYPES_HIDE: 'COMPANY_MANAGE_ABSENCETYPESW:HIDE',
    COMPANY_MANAGE_AVAILABILITIES_HIDE: 'COMPANY_MANAGE_AVAILABILITIES:HIDE',
    COMPANY_MANAGE_AVAILABILITIES_HIDE_DELETE: 'COMPANY_MANAGE_AVAILABILITIES:HIDE_DELETE',
    COMPANY_MANAGE_AVAILABILITIES_HIDE_EDIT: 'COMPANY_MANAGE_AVAILABILITIES:HIDE_EDIT',
    COMPANY_MANAGE_CONDITIONS_HIDE: 'COMPANY_MANAGE_CONDITIONS:HIDE',
    COMPANY_MANAGE_CONDITIONS_HIDE_EDIT: 'COMPANY_MANAGE_CONDITIONS:HIDE_EDIT',
    COMPANY_MANAGE_EMPLOYMENTCONDITIONS_HIDE_DELETE: 'COMPANY_MANAGE_EMPLOYMENTCONDITIONS:HIDE_DELETE',
    COMPANY_MANAGE_DEVICES_HIDE: 'COMPANY_MANAGE_DEVICES:HIDE',
    COMPANY_MANAGE_DEVICES_HIDE_DELETE: 'COMPANY_MANAGE_DEVICES:HIDE_DELETE',
    COMPANY_MANAGE_DEVICES_HIDE_EDIT: 'COMPANY_MANAGE_DEVICES:HIDE_EDIT',
    COMPANY_MANAGE_EMPLOYEES_HIDE: 'COMPANY_MANAGE_EMPLOYEES:HIDE',
    COMPANY_MANAGE_EMPLOYEES_HIDE_ADD: 'COMPANY_MANAGE_EMPLOYEES:HIDE_ADD',
    COMPANY_MANAGE_EMPLOYEES_HIDE_DELETE: 'COMPANY_MANAGE_EMPLOYEES:HIDE_DELETE',
    COMPANY_MANAGE_EMPLOYEES_HIDE_EDIT: 'COMPANY_MANAGE_EMPLOYEES:HIDE_EDIT',
    COMPANY_MANAGE_JOBTITLES_HIDE: 'COMPANY_MANAGE_JOBTITLES:HIDE',
    COMPANY_MANAGE_JOBTITLES_HIDE_ADD: 'COMPANY_MANAGE_JOBTITLES:HIDE_ADD',
    COMPANY_MANAGE_JOBTITLES_HIDE_DELETE: 'COMPANY_MANAGE_JOBTITLES:HIDE_DELETE',
    COMPANY_MANAGE_JOBTITLES_HIDE_EDIT: 'COMPANY_MANAGE_JOBTITLES:HIDE_EDIT',
    COMPANY_MANAGE_LOCATIONS_HIDE: 'COMPANY_MANAGE_LOCATIONS:HIDE',
    COMPANY_MANAGE_LOCATIONS_HIDE_ADD: 'COMPANY_MANAGE_LOCATIONS:HIDE_ADD',
    COMPANY_MANAGE_LOCATIONS_HIDE_DELETE: 'COMPANY_MANAGE_LOCATIONS:HIDE_DELETE',
    COMPANY_MANAGE_LOCATIONS_HIDE_EDIT: 'COMPANY_MANAGE_LOCATIONS:HIDE_EDIT',
    COMPANY_MANAGE_SHIFTBLOCKS_HIDE: 'COMPANY_MANAGE_SHIFTBLOCKS:HIDE',
    COMPANY_MANAGE_SHIFTBLOCKS_HIDE_DELETE: 'COMPANY_MANAGE_SHIFTBLOCKS:HIDE_DELETE',
    COMPANY_MANAGE_SHIFTBLOCKS_HIDE_EDIT: 'COMPANY_MANAGE_SHIFTBLOCKS:HIDE_EDIT',
    COMPANY_MANAGE_VIEW_HIDE: 'COMPANY_MANAGE_VIEW:HIDE',
    COMPANY_MANAGE_WORKPLACES_HIDE: 'COMPANY_MANAGE_WORKPLACES:HIDE',
    COMPANY_MANAGE_WORKPLACES_HIDE_DELETE: 'COMPANY_MANAGE_WORKPLACES:HIDE_DELETE',
    COMPANY_MANAGE_WORKPLACES_HIDE_EDIT: 'COMPANY_MANAGE_WORKPLACES:HIDE_EDIT',
    COMPANY_MANAGE_EMPLOYEES_LIMITS_HIDE_EDIT: 'COMPANY_MANAGE_EMPLOYEES_LIMITS:HIDE_EDIT',
    DASHBOARD_VIEW_HIDE: 'DASHBOARD_VIEW:HIDE',
    ECP_HIDE: 'ECP:HIDE',
    EMPLOYEES_CODE_NAMES: 'EMPLOYEES:CODE_NAMES',
    EMPLOYMENT_CONDITIONS_DISABLE_DEFAULT: 'EMPLOYMENT_CONDITIONS:DISABLE_DEFAULT',
    EXPORT_VIEW_HIDE: 'EXPORT_VIEW:HIDE',
    INTERCOM_DISABLE: 'INTERCOM:DISABLE',
    LANGUAGE_SETTINGS_HIDE: 'LANGUAGE_SETTINGS:HIDE',
    LOCATION_ATTENDANCE_CLOCK_REQUIRE_ALL: 'LOCATION_ATTENDANCE_CLOCK:REQUIRE_ALL',
    MANAGER_EDIT_OWN_ATTENDANCES: 'MANAGER:EDIT_OWN_ATTENDANCES',
    MANAGER_ROLE_HIDE: 'MANAGER_ROLE:HIDE',
    MANAGER_VIEW_EMPLOYEES_PAYROLL: 'MANAGER:VIEW_EMPLOYEES_PAYROLL',
    NOTIFICATIONS_VIEW_HIDE: 'NOTIFICATIONS_VIEW:HIDE',
    PAYROLL_LOCATION_VIEW_HIDE: 'PAYROLL_LOCATION_VIEW:HIDE',
    PAYROLL_SETTINGS_EDIT_DISABLE: 'PAYROLL_SETTINGS_EDIT:DISABLE',
    PAYROLL_VIEW_HIDE: 'PAYROLL_VIEW:HIDE',
    PAYROLL_VIEW_HIDE_EDIT: 'PAYROLL_VIEW:HIDE_EDIT',
    PRODUCTION_QUOTAS_VIEW_HIDE: 'PRODUCTION_QUOTAS_VIEW:HIDE',
    REPORTS_VIEW_HIDE: 'REPORTS_VIEW:HIDE',
    SCHEDULE_VIEW_HIDE: 'SCHEDULE_VIEW:HIDE',
    ALL_SETTINGS_VIEW_HIDE: 'ALL_SETTINGS_VIEW:HIDE',
    SETTINGS_LOCATIONS_HIDE: 'SETTINGS_VIEW:HIDE',
    WORKING_RULES_HIDE: 'WORKING_RULES:HIDE',
    SUPPLEMENTARY_EMPLOYEES_HIDE_MODIFY: 'SUPPLEMENTARY_EMPLOYEES:HIDE_MODIFY',
    SCHEDULE_VIEW_SUPPLEMENTARY_EMPLOYEES_HIDE_ADD: 'SCHEDULE_VIEW_SUPPLEMENTARY_EMPLOYEES:HIDE_ADD',
    ABSENCES_LEAVE_REQUEST_VIEW_HIDE: 'ABSENCES_LEAVE_REQUEST_VIEW:HIDE',
    ABSENCES_LIMIT_VIEW_HIDE: 'ABSENCES_LIMIT_VIEW:HIDE',
    COMPANY_MANAGE_ABSENCE_TYPES_HIDE: 'COMPANY_MANAGE_ABSENCE_TYPES:HIDE',
    SCHEDULE_EDIT_DISABLE: 'SCHEDULE_EDIT:DISABLE',
    COUNT_DAYS_WITH_SHIFTS_HIDE: 'COUNT_DAYS_WITH_SHIFTS:HIDE',
    OPENING_HOURS_HIDE: 'OPENING_HOURS:HIDE',
    ABSENCES_FOR_OTHERS_HIDE_ADD: 'ABSENCES_FOR_OTHERS:HIDE_ADD',
    COMPANY_MANAGE_LOCATIONS_HIDE_ASSIGN: 'COMPANY_MANAGE_LOCATIONS:HIDE_ASSIGN',
    ABSENCES_EDIT_HIDE: 'ABSENCES_EDIT:HIDE',
    BUDGET_INFO_DISABLE_EDIT: 'BUDGET_INFO:DISABLE_EDIT',
    BUDGET_INFO_HIDE: 'BUDGET_INFO:HIDE',
    RECOMMENDED_SCHEDULE_HIDE: 'RECOMMENDED_SCHEDULE:HIDE',
    RECOMMENDED_SCHEDULE_DISABLE_EDIT: 'RECOMMENDED_SCHEDULE:DISABLE_EDIT',
    BUDGET_TARGETS_HIDE: 'BUDGET_TARGETS:HIDE',
    BUDGET_TARGETS_DISABLE_EDIT: 'BUDGET_TARGETS:DISABLE_EDIT',
    ATTENDANCE_EDIT_HIGHER_EQUAL_DISABLE: 'ATTENDANCE_EDIT_HIGHER_EQUAL:DISABLE',
    ATTENDANCE_LABELS_MANAGE_HIDE: 'ATTENDANCE_LABELS_MANAGE:HIDE',
};
